export default __webpack_public_path__ + "static/invest-public-health-healthcare-accomplishment-3d-44cb0039f3c38c819d5cbef3c1bfc9e9.webp";